/*
 * Copyright (c) 2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    header: false,
    form: false
  },
  name: {
    displayName: 'sectionName'
  },
  tableCount: {
    form: false
  }
}
const config = {
  add: function (item) {
    item.tableType = 'Room'
    return hillo.postWithUploadFile('Section.php?op=add', item)
  },
  edit: function (item) {
    item.servantIds = JSON.stringify([])
    return hillo.postWithUploadFile('Section.php?op=update', item, {
      showLoading: true
    })
  },
  remove: function (id) {
    return hillo.post('Section.php?op=delete', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Section.php', {
      op: 'view',
      lang: GlobalSettings.getLang(),
      ...filter
    }))
      .content.filter(it => it.id !== '6')
  }
}

export default IKDataEntity.ModelFactory(entity, config)
